<template lang="pug">

el-table(:data="LogData" cell-class-name="logcell" height="200")
  el-table-column(width="180" :label="$t('Cuona.Device.header01')" prop="datetime")
  el-table-column(width="100" :label="$t('Cuona.Device.header02')" prop="type")
    template(slot-scope="scope")
      el-tag(:type="checkType(scope.row.type)" size="mini") {{ scope.row.type }}
  el-table-column(:label="$t('Cuona.Device.header03')" prop="event")
</template>

<script>
export default {
  data () {
    return {
      LogData: [{
        datetime: '2018-09-04 09:00:00',
        type: 'Admin',
        event: this.$t('Cuona.Messages.event04')
      },{
        datetime: '2018-09-03 12:00:00',
        type: 'Event',
        event: this.$t('Cuona.Messages.event03')
      },{
        datetime: '2018-09-02 14:15:00',
        type: 'CUONA',
        event: this.$t('Cuona.Messages.event05')
      },{
        datetime: '2018-09-02 12:15:00',
        type: 'Error',
        event: this.$t('Cuona.Messages.event06')
      },{
        datetime: '2018-09-01 12:15:00',
        type: 'Event',
        event: this.$t('Cuona.Messages.event02')
      },{
        datetime: '2018-09-01 12:00:00',
        type: 'CUONA',
        event: this.$t('Cuona.Messages.event01')
      }]
    }
  },
  methods: {
    checkType: function(type){
      switch(type){
        case "Admin": return ""; break;
        case "Event": return "success"; break;
        case "Error": return "danger"; break;
        case "CUONA": return "info"; break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";

.el-table ::v-deep {
  td.logcell {
    padding: 5px 0 5px 20px;
    font-size: 13px;
  }
}

</style>